template = require('./business_nature_options.html.slim')

angular.module('wbComponents').directive 'wbBusinessNatureOptions', ->
  scope:
    noSelectText: '='
  restrict: 'E'
  replace: true
  templateUrl: template
  link: ($scope, $el, $attrs) ->
    $scope.natures = [
      'Accounting',
      'Agriculture',
      'Automotive',
      'Banking',
      'Beauty Care',
      'Biotech',
      'BPO-KPO',
      'Broker/Dealer',
      'Business Development',
      'Call Center',
      'Clergy',
      'Clerical',
      'Commerce Merchandising',
      'Construction',
      'Construction Engineering',
      'Consultant (Financial Related)',
      'Consultant (Not Financial Related)',
      'Customer Service',
      'Defense',
      'Design',
      'Distributor',
      'Education',
      'Engineering',
      'Environment',
      'Event Management',
      'Facilities',
      'Finance - Other',
      'Financial Advisor',
      'Financial Management',
      'Financial Regulator Organization, SRO, or Exchange Member',
      'Firefighter',
      'Fitness/Beauty Treatment',
      'Franchise',
      'General Skilled labor',
      'Government - Federal',
      'Government - Other',
      'Government - State',
      'Grocery',
      'Guard-Security Services',
      'Healthcare',
      'Hospital',
      'Hotel',
      'Human Resources',
      'Import/Export',
      'Information Technology',
      'Installation-Maintenance Repair',
      'Insurance',
      'Interior Design',
      'Internal Sales',
      'Internet-E-Commerce',
      'Legal, Law, Attorney Services',
      'Management',
      'Manufacturing',
      'Marketing',
      'Media-Journalism-Newspaper-Magazine',
      'Medical',
      'Military',
      'Non-profit',
      'Nurse',
      'Oil and Gas',
      'Oil and Gas On/Offshore',
      'Other',
      'Pharmaceutical',
      'Police-Security',
      'Politics',
      'Professional Services',
      'Purchasing-Procurement',
      'QA-Quality Control',
      'Real Estate',
      'Research',
      'Restaurant-Food Service',
      'Retail',
      'Sales',
      'Science',
      'Security',
      'Service',
      'Shipping',
      'Site Engineering',
      'Social, Public Service',
      'Sports-Entertainment',
      'Statistics-Market Research',
      'Teaching',
      'Telecommunications',
      'Tourism',
      'Training',
      'Transportation',
      'Travel-Leisure-Tourism',
      'Veterinary Services',
      'Volunteering',
      'Warehouse',
      'Wholesale',
    ]
